import { defineMessages } from 'react-intl';

export default defineMessages({
  submit: {
    id: 'sentinel.components.modalForm.submit',
    defaultMessage: 'Submit',
  },
  cancel: {
    id: 'sentinel.components.modalForm.cancel',
    defaultMessage: 'Cancel',
  },
});



// WEBPACK FOOTER //
// ./src/components/ModalForm/messages.js